import React from "react";
import { Card, Progress } from "reactstrap";
import PropTypes from "prop-types";
import { CommonText } from "./TextCommon";
import httpService from "services/httpService";

export default function CardDetail(props) {
  const { item, number } = props;

  console.log("number", number);

  return (
    <Card body className="cardChildrenDashboard">
      <div className="cardTitle">
        <CommonText level={8} mt={0} color="#72777b">
          {item.title}
        </CommonText>
        <div className="cardIcon">
          <i className={item.nameIcon} />
        </div>
      </div>
      <div className="contentOfCard">
        <CommonText level={6} mt={0} color="#2d2d2d">
          {number}
        </CommonText>
        <CommonText level={7} mt={0} color="#2d2d2d">
          {item.content}
        </CommonText>
      </div>
    </Card>
  );
}

CardDetail.propTypes = {
  item: PropTypes.object,
  number: PropTypes.number,
};
